import React from "react";
import PropTypes from "prop-types";

import styles from "./MessagePage.css";

const MessagePage = ({ backgroundUrl, message, redirectLabel, redirectTo, title }) => (
  <div className={styles.root} style={{ backgroundImage: `url('${backgroundUrl}')` }}>
    <div className={styles.content}>
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: message }} />
      {redirectTo && redirectLabel && (
        <a className={styles.back} href={redirectTo}>
          {redirectLabel}
        </a>
      )}
    </div>
  </div>
);

MessagePage.propTypes = {
  backgroundUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  redirectTo: PropTypes.string,
  redirectLabel: PropTypes.string,
};

export default MessagePage;
